/**
 * 检查当前设备是否为移动设备
 * @returns {boolean} 如果是移动设备返回true，否则返回false
 */
const isMobileDevices = () => {
  // 检查用户代理字符串中的常见移动设备模式
  const userAgent =
    navigator.userAgent || navigator.vendor || (window as any).opera;

  // 常见移动设备正则表达式模式
  const mobileRegex =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

  // 检查触摸支持(可选的额外检查)
  const hasTouchSupport =
    'ontouchstart' in window || navigator.maxTouchPoints > 0;

  // 检查屏幕尺寸(可选的额外检查)
  const isSmallScreen = window.innerWidth < 768;

  // 如果用户代理匹配或(支持触摸且屏幕较小)则返回true
  return mobileRegex.test(userAgent) || (hasTouchSupport && isSmallScreen);
};

/**
 * 检查当前路径是否属于"有移动端覆盖"的页面。
 */
const isMobilePages = (pathname: string) => {
  const paths: string[] = [
    'operate/aiseeDetail',
    'feedback/aiseeDetail',
    'aiseeList',
    'aiseeIssue',
    'overview',
    '/',
  ];
  return paths.some((path) => pathname.match(new RegExp(`${path}(?:/.*)?$`)));
};

/**
 * 检查当前页面是否移动端的主页面
 * @returns {boolean} 如果是主页面返回true，否则返回false
 */
const isMobileMainPage = (pathname: string) => {
  const paths: string[] = ['operate/aiseeList', 'overview'];
  return paths.some((path) => pathname.includes(path));
};

const BASE_SIZE = 16; // 1rem

/**
 * px 转 rem
 */
export function px2rem(px: number | string): string {
  const value = typeof px === 'string' ? parseFloat(px) : px;
  return `${value / BASE_SIZE}rem`;
}

export { isMobileDevices, isMobileMainPage, isMobilePages };
